import * as React from "react";

import { GenericForm } from "../../hooks";

export interface InputContainerProps {
  className?: string;

  name: string;
  displayName?: string;
  required?: boolean;
  notice?: string;
  noticeWarningColor?: boolean;

  form: GenericForm;

  header?: React.FunctionComponent;

  isCustomError?: () => boolean;
  doesCustomErrorExtendStandardErrorState?: () => boolean;
  customErrorComponent?: () => React.ReactNode;
}

export const InputContainer: React.FunctionComponent<InputContainerProps> = (
  props
) => {
  const errorPropertyKey = `${props.name}Error`;

  const amIRenderingACustomError = props.isCustomError?.() || false;

  const doesCustomErrorExtendStandardErrorState =
    props.doesCustomErrorExtendStandardErrorState?.() || false;

  return (
    <div
      className={`input-container ${props.className || ""} ${
        props.form[errorPropertyKey] || doesCustomErrorExtendStandardErrorState
          ? "error"
          : ""
      } named-${props.name}`}
    >
      {props.displayName && props.header ? (
        <props.header>{props.displayName}</props.header>
      ) : props.displayName ? (
        <label className="title">
          <span className="content">{props.displayName}</span>
          {props.required && <span className="required-asterix">&nbsp;*</span>}
        </label>
      ) : null}

      {props.notice && (
        <p
          className={`notice ${props.noticeWarningColor ? "warning" : "fine"}`}
        >
          {props.notice}
        </p>
      )}

      {props.children}

      {amIRenderingACustomError ? (
        props.customErrorComponent?.()
      ) : props.form[errorPropertyKey] ? (
        <p className="error-message">{props.form[errorPropertyKey]}</p>
      ) : null}
    </div>
  );
};
